
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 2","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17.99 18.64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.49 2.54h-3.82V.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5v2.04h-7.1V.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5v2.04H.5c-.28 0-.5.22-.5.5v15.1c0 .28.22.5.5.5h16.99c.28 0 .5-.22.5-.5V3.04c0-.28-.22-.5-.5-.5zm-12.92 1v1.91c0 .28.22.5.5.5s.5-.22.5-.5V3.54h7.1v1.91c0 .28.22.5.5.5s.5-.22.5-.5V3.54h3.32v4.25H1V3.54h3.57zM1 17.64V8.79h15.99v8.85H1z","data-name":"Layer 1"}})])
          )
        }
      }
    